import Vue from 'vue'

// Fundraisers

export const PageFundraisers = Vue.component('page-fundraisers', require('./components/index/PageFundraisers.vue'))
export const FundraisersFilter = Vue.component('fundraisers-filter', require('./components/index/FundraisersFilter.vue'))
export const FundraiserProject = Vue.component('fundraiser-project', require('./components/index/FundraiserProject.vue'))
export const PageShowFundraiser = Vue.component('page-show-fundraiser', require('./components/show/PageShowFundraiser.vue'))
export const FundraiserProfile = Vue.component('fundraiser-profile', require('./components/show/FundraiserProfile.vue'))
export const FundraiserUpdates = Vue.component('fundraiser-updates', require('./components/show/FundraiserUpdates.vue'))
export const FundingDetails = Vue.component('funding-details', require('./components/show/FundingDetails.vue'))
export const FundingDonators = Vue.component('funding-donators', require('./components/show/FundingDonators.vue'))
export const DonatorsComments = Vue.component('donators-comments', require('./components/show/DonatorsComments.vue'))
export const FundraiserReportQuestion = Vue.component('fundraiser-report-question', require('./components/show/FundraiserReportQuestion'))
export const LoginButton = Vue.component('login-button', require('./components/show/LoginButton.vue'))
export const Checkout = Vue.component('checkout', require('./components/show/Checkout'))
export const EditProfile = Vue.component('edit-profile', require('./components/show/EditProfile'))

export const FundraiserCreatePage = Vue.component('fundraiser-create-page', require('./components/create/FundraiserCreatePage'))



// WEBPACK FOOTER //
// ./resources/js/views/fundraisers/index.js